import axios from 'axios';

export default {
  default() {
    return axios.create({
      baseURL : process.env.LOCALITY_SERVICE_API,
      headers : {
        Accept         : 'application/json',
        'Content-Type' : 'application/json',
        'x-api-key'    : process.env.LOCALITY_SERVICE_API_KEY
      }
    });
  }
};
